import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [authOpen, setAuthOpen] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data.user))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  };

  const demoLogin = async () => {
    const { data } = await api.post("/auth/demo");
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const toggleFavorite = async (kind, ref) => {
    if (!user) {
      setAuthOpen(true);
      return null;
    }
    const { data } = await api.post("/favorites/toggle", { kind, ref });
    setUser((u) => {
      const key = kind === "supervisor" ? "favorite_supervisors" : "favorite_companies";
      const list = new Set(u[key] || []);
      if (data.favorited) list.add(ref);
      else list.delete(ref);
      return { ...u, [key]: Array.from(list) };
    });
    return data.favorited;
  };

  const isFavorite = (kind, ref) => {
    if (!user) return false;
    const key = kind === "supervisor" ? "favorite_supervisors" : "favorite_companies";
    return (user[key] || []).includes(ref);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, login, register, demoLogin, logout, authOpen, setAuthOpen, toggleFavorite, isFavorite }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
